<template>
  <div id="sp-menu" @click="closeMenu">
    <div class="sp-menu-items">
      <ul>
        <li v-for="(link, index) of links" :key="index">
          <router-link @click.native="$parent.handleLinkValue(link.to)" :to="link.to">{{ $t(link.title) }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    links: Array
  },
  methods: {
    clickLogo() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    closeMenu() {
      this.$emit("closeMenu");
    },
  }
}
</script>

<style lang="scss" scoped>
#sp-menu {
  position: fixed;
  height: 100vh;
  width: 100vw;
  left: 0;
  background: $background;
}

.sp-menu-items {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  > ul {
    padding: 0;
    list-style-type: none;

    > li {
      font-size: 20px;
      height: 80px;
      width: 200px;
      max-width: 80vw;
      &:not(:last-child) {
        border-bottom: 2px solid $primary2;
      }
    }
    > li > * {
      display: flex;
      align-items: center;
      height: 100%;
    }
  }
}
</style>